export const companyInfo = {
  name: 'BANSAL MOTORS',
  tagline: 'Authorised Commercial Vehicle Dealer | Est. 2002',
  established: 'April 2002',
  partner: 'Parveen Bansal',
  location: 'Karnal, Haryana',
  fullAddress: 'G.T. Madanpur Road, Opposite Near Neelkhant Dhaba, Karnal, Haryana 132001, India',
  phone: '9812999358',
  whatsapp: '919812999358',
};

export const companyStats = [
  { label: 'Established', value: '2002' },
  { label: 'Vehicles Delivered', value: '1000+ per year' },
  { label: 'Genuine Support', value: '100%' },
];

export const partners = [
  'Ratan Lal Bansal Ji',
  'Vikas Bansal',
  'Parveen Bansal',
  'Gaurav Bansal',
];

export const services = [
  'Vehicle Sales',
  'Commercial Vehicle Trading',
  'Customer Support',
  'Vehicle Consultation',
  'Best Service',
];

export const products = [
  { name: 'Bus', description: 'School & Tourist' },
  { name: 'LMD', description: 'Light Commercial Vehicle' },
  { name: 'HD', description: 'Heavy Commercial Vehicle' },
];

export const busSegment = {
  schoolBuses: '90%',
  touristBuses: '10%',
  description: 'Trusted by 100+ schools across Haryana',
};
